import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";
import {FITH2WinConfig, IBigWinLevel} from "../configs/FITH2WinConfig";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class FITH2BigWinPresentation implements SimplePresentation {
    private readonly FADE_AWAY_DURATION: number = 3;
    private _bigWinLevels: IBigWinLevel[];

    constructor() {
    }

    shouldRun(): boolean {
        return !FireInTheHole2.model.gameData.brokeTheBank && FireInTheHole2.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = this._bigWinLevels = FITH2WinConfig.getBigWinLevels(FireInTheHole2.model.winRatio),
        maxLevel:number = levels.length;
        FireInTheHole2.bigWinView.maxLevel = maxLevel;

        const totalWin: number = FireInTheHole2.model.gameData.accumulatedRoundWin,
            tl: gsap.core.Timeline = gsap.timeline(),
            startTime: number =  0,
        shakeDuration:number = 1.715;
        tl.add(FireInTheHole2.gameViewContainer.addDimmer(true, 0.5, 0.7), 0);
        if(FireInTheHole2.model.data.mode[0] === "F"){
            tl.add(()=>{FireInTheHole2.keypadPlugin.setWin(0);}, startTime+0.7);
        }
        //for (let i: number = 0; i < 6; i++) {
        //    FireInTheHole2.reelArea.allReels[i].reelView.getAllSymbols().forEach((sym: FITH2Symbol) => {
        //        tl.add(sym.getShakeAnimation({duration:4, x:2, y:1}), startTime);
        //    });
        //}

        tl.add(()=>{FITH2SoundManager.playBigWinLevelSound(0);}, 0);

        tl.add(FireInTheHole2.bigWinView.show(0.1), 0);
        let levelStartTime:number = 0;
        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = (index === 0)?0:bigWinLevel.from * FireInTheHole2.model.gameData.playedBetValue,
                to: number = ((index+1) === maxLevel)?totalWin:bigWinLevel.to * FireInTheHole2.model.gameData.playedBetValue;
            tl.add(() => {
                controller.setSkipCallback(() => {
                    FireInTheHole2.bigWinView.onAbort(bigWinLevel.id-1);
                    tl.seek(bigWinLevel.type + "_end", false);
                });
            }, levelStartTime);
            tl.add([
                ()=>{
                    FITH2SoundManager.playBigWinLevelSound(index);
                },
                FireInTheHole2.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id)
            ], levelStartTime);
            tl.addLabel(bigWinLevel.type + "_end");
            levelStartTime = tl.duration();
        }


        tl.add(() => {
            FireInTheHole2.bigWinView.hide(this.FADE_AWAY_DURATION);
        });
        tl.add(() => {
            controller.finish()
            //FireInTheHole2.keypadPlugin.setWin(FireInTheHole2.model.gameData.accumulatedRoundWin, true, FITH2Helper.isWinBelowStake());
        }, `+=${this.FADE_AWAY_DURATION * 0.8}`);

    }
}
